import {
    GetProvinces,
    GetCitys,
    GetAreas,
    GetAgentList,
    GetParmConfig,
    GetProductClass,
    GetAgentConsigneeList,
    Consignee_Add,
    GetEmployList,
    ConsigneeSetDefault
} from '@api/commonApi.js';

import {
    lg,
    cloneDeep,
    isCorrectVal,
    util
} from 'utils';

//组件
import areaSelect from 'area-select';

export default {
    components: {
        'area-select': areaSelect
    },
    props: {
        value: {
            default: {}
        }
    },
    data() {
        return {
            addAddressBtnLoading: false,
            AgentId: "",
            CustomerId: "",
            diabledProv: false,
            diabledCity: false,
            dialogVisible: false,
            isReadOnly: false,
            areaInfo: this.getAreaInfo(),
            areaDisabled: false,
            AgentAddressList: [],
            AddAddress: this.getAddAgentAddress(),
            opts: {},
            result: {}
        };
    },
    watch: {
        value: {
            deep: true,
            handler: function (curVal, oldVal) {

            }
        }
    },
    computed: {

    },
    methods: {
        getInitData() {
            return cloneDeep({});
        },
        getSettings() {
            return cloneDeep({
                isLimitArea: false,
                ProvId: "",
                CityId: "",
                AreaId: "",
                provName: "",
                cityName: "",
                areaName: "",
                AgentId: "",
                CustomerId: ""
            });
        },
        getAddAgentAddress() {
            return cloneDeep({
                CustomerId: "",
                AgentId: "",
                Consignee: '',
                ConsigneeTel: '',
                IsDefault: false,
                ConsigneeAdress: '',
                ConsigneeProvince: '',
                ConsigneeCity: '',
                ConsigneeArea: ''
            });
        },
        getAreaInfo() {
            return cloneDeep({
                Provinces_Id: null,
                City_Id: null,
                Area_Id: null,
            });
        },
        getSelectAddressInfo() {
            return cloneDeep({
                Address: '',
                Consignee: '',
                ConsigneeTel: '',
                IsDefault: false
            });
        },
        show(options) {
            let opts = Object.assign({}, this.getSettings(), options);
            this.opts = opts;
            this.AgentId = opts.AgentId;
            this.CustomerId = opts.CustomerId;
            this.dialogVisible = true;
            this.GetAgentConsigneeListServiceFn();
            this.initAddressSelect();
        },
        initAddressSelect() {
            if (this.opts.isLimitArea) {
                this.$nextTick(() => {
                    this.areaInfo = Object.assign({}, this.getAreaInfo(), {
                        Provinces_Id: this.opts.ProvId,
                        City_Id: this.opts.CityId
                    });
                    this.diabledProv = true;
                    this.diabledCity = true;
                });
            } else {
                this.diabledProv = false;
                this.diabledCity = false;
            }
        },
        closeCallback() {
            this.resetForm();
            this.opts = {};
            this.diabledProv = false;
            this.diabledCity = false;
        },
        addAddress() {
            let areaselectObj = this.$refs.areaSelect.validate();

            let flag = util.checkForm({
                ele: this,
                rules: [{
                    name: "联系方式",
                    value: this.AddAddress.ConsigneeTel,
                    phone: true
                }]
            });

            if (!flag) {
                return;
            }

            if (!areaselectObj) {
                return;
            }
            this.AddAddress.AgentId = this.AgentId;
            this.AddAddress.CustomerId = this.CustomerId;
            this.AddAddress.ConsigneeProvince = areaselectObj.Provinces_Id;
            this.AddAddress.ConsigneeCity = areaselectObj.City_Id;
            this.AddAddress.ConsigneeArea = areaselectObj.Area_Id;
            let params = this.AddAddress;
            this.addAddressBtnLoading = true;
            Consignee_Add(params).then(res => {
                this.addAddressBtnLoading = false;
                util.doResult(this, res, () => {
                    this.GetAgentConsigneeListServiceFn(() => {
                        if (this.opts.isLimitArea) {
                            this.AddAddress.ConsigneeAdress = "";
                            this.AddAddress.Consignee = "";
                            this.AddAddress.ConsigneeTel = "";
                            this.areaInfo.Area_Id = "";
                            this.$refs.areaSelect.clearAreaData();
                        } else {
                            this.areaInfo = this.getAreaInfo();
                            this.AddAddress = this.getAddAgentAddress();
                            this.$refs.areaSelect.resetFields();
                        }
                    });
                });
            });

        },
        resetForm() {
            //this.AgentAddressList = [];
            this.areaInfo = this.getAreaInfo();
            this.AddAddress = this.getAddAgentAddress();
            this.$refs.areaSelect.resetFields();
        },
        selectAddress(item) {
            if (this.opts.isLimitArea) {
                if (item.Address.indexOf(this.opts.provName) > -1 && item.Address.indexOf(this.opts.cityName) > -1) {
                    this.closeAndSetSelectAddress(item);
                } else {
                    this.$notify({
                        title: '警告',
                        message: '请选择与签约区域省市相同的地址！',
                        type: 'warning'
                    });
                }
            } else {
                this.closeAndSetSelectAddress(item);
            }
        },
        closeAndSetSelectAddress(item) {
            this.dialogVisible = false;
            this.$emit('selectAddress', item);
        },
        setDefaultAddress(index, item) {
            let Params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                Id: item.Id,
                AgentId: this.AgentId,
                CustomerId: this.CustomerId
            };
            ConsigneeSetDefault(Params).then(res => {
                util.doResult(this, res, () => {
                    GetAgentConsigneeList(Params).then(res => {
                        util.doResult(this, res, () => {
                            this.$notify({
                                title: '成功',
                                message: "设置默认地址成功",
                                type: 'success'
                            });
                            this.AgentAddressList = res.data.Data;
                        });
                    });
                });
            });
        },
        GetAgentConsigneeListServiceFn(callback) {
            let Params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                AgentId: this.AgentId,
                CustomerId: this.CustomerId
            };
            GetAgentConsigneeList(Params).then(res => {
                util.doResult(this, res, () => {
                    this.AgentAddressList = res.data.Data;
                    if (typeof callback == "function") {
                        callback();
                    }
                });
            });
        }
    },
    mounted() {

    }
};


// WEBPACK FOOTER //
// ./src/common/components/operateAddressDialog/vm.js